import { createCachedSelector } from 're-reselect';
import { useSelector } from 'react-redux';
import { IGlobalReduxStore } from 'store';
import { B2BLoginResponseUserObject } from 'store/reducers/auth/authReducer.types';
import { isUserObjectB2bType } from 'types/common.types';

const getUser = (state: IGlobalReduxStore) => state.auth.user;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getOrgSettingsFromUser = (user: any) => {
  if (user && isUserObjectB2bType(user)) {
    const b2bUser = user as B2BLoginResponseUserObject;
    if (b2bUser.communities_attributes && b2bUser.communities_attributes.length > 0) {
      return b2bUser.communities_attributes[0].organization;
    }
  }
  return null;
};

export const orgSettingsSelector = createCachedSelector([getUser], (user) => {
  return getOrgSettingsFromUser(user);
})((state) => state.auth.user?.id || 'NO_USER');

export const hasMarketplaceSelector = createCachedSelector([orgSettingsSelector], (orgSettings) => {
  return orgSettings?.hasMarketplace || false;
})((state) => state.auth.user?.id || 'NO_USER');

export const orgIdSelector = createCachedSelector([orgSettingsSelector], (orgSettings) => {
  return orgSettings?.id || null;
})((state) => state.auth.user?.id || 'NO_USER');

export const orgNameSelector = createCachedSelector([orgSettingsSelector], (orgSettings) => {
  return orgSettings?.name || null;
})((state) => state.auth.user?.id || 'NO_USER');

export const agencyLicenceNumberSelector = createCachedSelector(
  [orgSettingsSelector],
  (orgSettings) => {
    return orgSettings?.licenceNumber || null;
  },
)((state) => state.auth.user?.id || 'NO_USER');

export const useOrgSettingsSelector = () => useSelector(orgSettingsSelector);
export const useHasMarketplaceSelector = () => useSelector(hasMarketplaceSelector);
export const useOrgIdSelector = () => useSelector(orgIdSelector);
export const useOrgNameSelector = () => useSelector(orgNameSelector);
export const useAgencyLicenceNumberSelector = () => useSelector(agencyLicenceNumberSelector);

export const communityListSelector = createCachedSelector([getUser], (user) => {
  if (user && isUserObjectB2bType(user)) {
    const b2bUser = user as B2BLoginResponseUserObject;
    if (b2bUser.communities_attributes && b2bUser.communities_attributes.length > 0) {
      return b2bUser.communities_attributes.map((community) => ({
        id: community.id,
        name: community.name,
      }));
    }
  }
  return [];
})((state) => state.auth.user?.id || 'NO_USER');

export const useCommunityListSelector = () => useSelector(communityListSelector);
